import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import "antd/dist/antd.css";
import "./App.css";
import Navbar from "./components/utils/Navbar";
import Footer from "./components/utils/Footer";
import TaxForm from "./components/TaxForm";
import EmployeeTable from "./components/EmployeeTable";
import MiscModal from "./components/utils/MiscModal";
import TaxTable from "./components/TaxTable";
import TaxCalculationReport from "./components/TaxCalculationReport";
import TempNav from "./components/TempNav";

function App() {
  return (
    <div className="App">
      <MiscModal />
      <Router>
        <Navbar />
        <Route exact path="/" component={TempNav} />
        <Route exact path="/tax-form" component={TaxForm} />
        <Route exact path="/tax-table" component={TaxTable} />
        <Route exact path="/loonslip" component={TaxTable} />
        <Route
          exact
          path="/loonslip-calculatie"
          component={TaxCalculationReport}
        />
        <Route exact path="/employee-table" component={EmployeeTable} />
        <Footer />
      </Router>
    </div>
  );
}

export default App;
